<template lang="pug">
  div.header-user-name
    a(v-click-outside="close" @click.prevent="toggleClientMenu") {{ user.name }} さん
    div.client-menu(v-show="openClientMenu")
      ul
        li.mylist(v-if="user.has_basic")
          router-link(
            :to="{ name: 'JobList' }",
            @click.native="toggleClientMenu"
          ) 求人リスト
        li.mysearch(v-if="user.has_basic")
          router-link(
            :to="{ name: 'SearchConditions' }",
            @click.native="toggleClientMenu"
          ) 求人検索管理
        li.mysearch(v-if="user.has_basic && user.new_job_notification")
          router-link(
            :to="{ name: 'JobNotificationSettings' }",
            @click.native="toggleClientMenu"
          ) 通知設定
        li.mysearch(v-if="user.has_basic")
          router-link(
            :to="{ name: 'ExclusionCompanyName' }",
            @click.native="toggleClientMenu"
          ) 除外企業管理
        li.mysearch(v-if="user.has_basic")
          router-link(
            :to="{ name: 'InclusionCompanyName' }",
            @click.native="toggleClientMenu"
          ) 登録企業管理
        li.mylist(v-if="user.has_basic")
          router-link(
            :to="{ name: 'CompanyList' }",
            @click.native="toggleClientMenu"
          ) 事業所リスト
        li.mylist(v-if="user.has_starting_business")
          router-link(
            :to="{ name: 'StartingBusinessList' }",
            @click.native="toggleClientMenu"
          ) 開業情報リスト
        li.mysearch(v-if="user.has_basic && user.display_aggregations && !this.spMode")
          router-link(
            :to="{ name: 'AggJobSearchConditions' }",
            @click.native="toggleClientMenu"
          ) 市況分析管理
        li.logout
          a(v-if="!logouting" @click.prevent="signOut") ログアウト
          a.disabled(v-else) ログアウト中
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import { ErrorMessages } from '../../constants'

  export default {
    directives: { ClickOutside },
    mounted () {
      this.popupItem = this.$el
    },
    computed: {
      ...mapGetters({
        logouting: 'session/logouting',
        spMode: 'common/spMode',
      }),
      ...mapState({
        user: state => state.user.detail,
      }),
    },
    data () {
      return {
        openClientMenu: false,
      }
    },
    methods: {
      close () {
        this.openClientMenu = false
      },
      toggleClientMenu () {
        if (!this.spMode) {
          this.openClientMenu = !this.openClientMenu
        }
      },
      async signOut () {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('session/signOut')
          this.$router.push({ name: 'SignIn' })
        } catch (e) {
          if (e.some(errorMessage => errorMessage.message === ErrorMessages.NO_AUTHORIZATION)) {
            this.$router.push({ name: 'SignIn' })
          } else {
            this.$store.dispatch('common/pushToastError', { error: e })
          }
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/PrivatePageHeaderUserName.vue